<script setup>
import CompetitorHistoryTable from '@frontJs/components/tables/projectManagement/modules/CompetitorHistoryTable.vue';
import ProjectManagementLayout from '@frontJs/layouts/ProjectManagementLayout.vue';
import { Head } from '@inertiajs/vue3';
import ContainerRoot from '@js/components/containers/ContainerRoot.vue';
import TabLayout from '@js/components/tabs/TabLayout.vue';
import PageTitle from '@js/components/titles/PageTitle.vue';
import { h } from 'vue';

const { tenant, competitor, countries } = defineProps({
    tenant: {
        type: Object,
        required: true,
    },
    competitor: {
        type: Object,
        required: false,
    },
    countries: {
        type: Array,
        required: true,
    },
});

defineOptions({ layout: ProjectManagementLayout });
</script>

<template>
    <Head>
        <title>
            {{ competitor.name }} - Concurrents Modules - Gestion de projet -
            Datakepler
        </title>
    </Head>

    <PageTitle :tenant-name="tenant.name">
        Gestion de projet - Modules - Concurrents - {{ competitor.name }}
    </PageTitle>

    <ContainerRoot v-if="competitor.description" class="mb-4">
        <div class="wysiwyg" v-html="competitor.description"></div>
    </ContainerRoot>

    <TabLayout
        :tabs="{
            ...(competitor.seoEnabled && competitor.numberOfSeoKeywords > 0
                ? {
                      seo: {
                          title: 'SEO',
                          content: h(CompetitorHistoryTable, {
                              tenant,
                              competitor,
                              type: 'seo',
                              countries,
                          }),
                      },
                  }
                : {}),
            ...(competitor.seaEnabled && competitor.numberOfSeaKeywords > 0
                ? {
                      sea: {
                          title: 'SEA',
                          content: h(CompetitorHistoryTable, {
                              tenant,
                              competitor,
                              type: 'sea',
                              countries,
                          }),
                      },
                  }
                : {}),
        }"
    />
</template>
